module.exports = __webpack_public_path__ + "img/11825384_S.ffdeb1be.png";